/**
 * SAP CONFIDENTIAL
 *
 * This software is confidential proprietary software licensed by SAP SE
 * and is not to be used, duplicated or disclosed to anyone without the
 * prior written permission of SAP.
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class CompanyGenealogyConfigService {
  private companyUrl: string = environment.host + '/company/';
  private companyConfigUrl: string = environment.host + '/company/configuration/';
  private flagsUrl: string = environment.host + '/flag/metadata?tabType=' + 'flagPage/lineageconfig';
  private url: string = environment.host + '/company?tabType=' + 'LCNF';

  constructor(private http: HttpClient) {}

  public getCompanyGenConfiguration(companyId: any) {
    return this.http.get(this.companyUrl.toString() + companyId + '/configuration').toPromise();
  }

  public getCompanyGenConfigurationTabType(companyId: any) {
    return this.http.get(this.companyUrl.toString() + companyId + '/configuration?tabType=' + 'lineageconfiguration').toPromise();
  }

  public updateCompanyGenealogyConfig(payload: any, companyGenConfigId: any) {
    return this.http.put(this.companyConfigUrl.toString() + companyGenConfigId, payload).toPromise();
  }

  public createCompanyGenealogyConfig(payload: any, companyId: any) {
    return this.http.post(this.companyUrl.toString() + companyId + '/configuration', payload).toPromise();
  }

  public getAllFlags() {
    return this.http.get(this.flagsUrl.toString()).toPromise();
  }

  public getAllCompanies() {
    return this.http.get(this.url.toString()).toPromise();
  }
}
